export default "__VITE_ASSET__306ff9c4__"